import { useLocation, useNavigate } from "react-router";
import { useEffect, useState } from "react";
import Navbar from "./Navbar";
import { handleOpenChat } from "utils/analytics";

export default function Header(){
  const [showNavbar, setShowNavbar] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();

  const menuHandler = () => {
    setShowNavbar(!showNavbar);
  }

  useEffect(() => {
    setShowNavbar(false)
  }, [location.pathname])

  return (
    <header className={`flex justify-between items-center h-32 w-full absolute top-0 px-5 lg:px-8 z-50 header-white`}>
      <div onClick={() => navigate("/") } className="flex items-center cursor-pointer">
        <img className="h-24" src="logo.png" alt="Peromar" />
      </div>
      <Navbar show={showNavbar} />
      <div className="hidden lg:flex"> 
          <div className="py-2 w-36 px-6 text-white bg-emerald-500 rounded flex">
            <button onClick={handleOpenChat} type="submit">Fale conosco</button>
          </div>
      </div>
      <div onClick={menuHandler} className="flex flex-wrap items-center w-10 h-10 mr-1 lg:hidden cursor-pointer">
          <span className="block w-full h-1 bg-emerald-500 rounded"></span>
          <span className="block w-full h-1 bg-emerald-500 rounded"></span>
          <span className="block w-full h-1 bg-emerald-500 rounded"></span>
      </div>
    </header>
  )
}